export default __webpack_public_path__ + "static/blogImg-ff36b467f8ac7c7060da52d57244f677.svg";